import { basicCRUDAction, hotGetAction } from 'utils';
import { service } from 'services';
import { ACTIONS_TYPES } from '../helper';

export default {
  create: async ({ dcId, serverId, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.CREATE,
    apiResult: service.nic.create({ dcId, serverId, properties }),
  }),

  update: async ({
    dcId, nicId, properties, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.UPDATE,
    apiResult: service.nic.update({
      dcId, nicId, properties, serverId,
    }),
  }),

  delete: async ({ dcId, nicId, serverId }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.DELETE,
    apiResult: service.nic.delete({ dcId, nicId, serverId }),
  }),

  get: async ({ dcId, nicId, serverId }) => hotGetAction({
    action: ACTIONS_TYPES.NIC.GET,
    apiResult: service.nic.get({ dcId, nicId, serverId }),
  }),

  getAll: async ({ dcId, serverId }) => hotGetAction({
    action: ACTIONS_TYPES.NIC.GET_ALL,
    apiResult: service.nic.getAll({ dcId, serverId }),
  }),

  firewallRuleAdd: async ({
    dcId, nicId, properties, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.FIREWALL_RULE_ADD,
    apiResult: service.nic.firewallRuleAdd({
      dcId, nicId, properties, serverId,
    }),
  }),

  firewallRuleGet: async ({
    dcId, nicId, ruleId, serverId,
  }) => hotGetAction({
    action: ACTIONS_TYPES.NIC.FIREWALL_RULE_GET,
    apiResult: service.nic.firewallRuleGet({
      dcId, nicId, ruleId, serverId,
    }),
  }),

  firewallRuleGetAll: async ({ dcId, nicId, serverId }) => hotGetAction({
    action: ACTIONS_TYPES.NIC.FIREWALL_RULE_GET_ALL,
    apiResult: service.nic.firewallRuleGetAll({ dcId, nicId, serverId }),
    isRetrieveItems: true,
  }),

  firewallRuleUpdate: async ({
    dcId, nicId, properties, ruleId, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.FIREWALL_RULE_UPDATE,
    apiResult: service.nic.firewallRuleUpdate({
      dcId, nicId, properties, ruleId, serverId,
    }),
  }),

  firewallRuleDelete: async ({
    dcId, nicId, ruleId, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.FIREWALL_RULE_DELETE,
    apiResult: service.nic.firewallRuleDelete({
      dcId, nicId, ruleId, serverId,
    }),
  }),

  flowlogAdd: async ({
    dcId, nicId, properties, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.FLOWLOG_ADD,
    apiResult: service.nic.flowlogAdd({
      dcId, nicId, properties, serverId,
    }),
  }),

  flowlogGet: async ({
    dcId, flowlogId, nicId, serverId,
  }) => hotGetAction({
    action: ACTIONS_TYPES.NIC.FLOWLOG_GET,
    apiResult: service.nic.flowlogGet({
      dcId, flowlogId, nicId, serverId,
    }),
  }),

  flowlogGetAll: async ({ dcId, nicId, serverId }) => hotGetAction({
    action: ACTIONS_TYPES.NIC.FLOWLOG_GET_ALL,
    apiResult: service.nic.flowlogGetAll({ dcId, nicId, serverId }),
    isRetrieveItems: true,
  }),

  flowlogUpdate: async ({
    dcId, flowlogId, nicId, properties, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.FLOWLOG_UPDATE,
    apiResult: service.nic.flowlogUpdate({
      dcId, flowlogId, nicId, properties, serverId,
    }),
  }),

  flowlogDelete: async ({
    dcId, flowlogId, nicId, serverId,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.NIC.FLOWLOG_DELETE,
    apiResult: service.nic.flowlogDelete({
      dcId, flowlogId, nicId, serverId,
    }),
  }),
};
